import { useState, useEffect } from 'react';
import SEO from './SEO';
import NavBar from './NavBar';
import Hero from './Hero';
import Services from './Services';
import Portfolio from './Portfolio';
import Blog from './Blog';
import CaseStudies from './CaseStudies';
import HowWeWork from './HowWeWork';
import Packages from './Packages';
import Footer from './Footer';
import '../styles/FrontPage.css';

const FrontPage = () => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const footerHeight = 400; // Approximate footer height

      // Hide scroll down indicator when near bottom (before footer)
      if (scrollPosition >= documentHeight - footerHeight) {
        setShowScrollIndicator(false);
      } else {
        setShowScrollIndicator(true);
      }

      // Show scroll to top button after scrolling 300px
      if (window.scrollY > 300) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="front-page">
      <SEO />

      <div className="page-wrapper">
        {/* Main content */}
        <NavBar />

        <main className="main-content">
          <Hero />
          <Services />
          <Portfolio />
          <CaseStudies />
          <HowWeWork />
          <Packages />
          <Blog />
        </main>

        <Footer />
      </div>

      {/* Scroll indicator */}
      {showScrollIndicator && (
        <div className="scroll-indicator">
          <div className="scroll-chevron">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      )}

      {/* Scroll to top button */}
      {showScrollToTop && (
        <button
          className="scroll-to-top-button"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 14L12 9L7 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default FrontPage;
